// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2SDkQ","vLegacy":"SelectSecondary_vLegacy__153vu","error":"SelectSecondary_error__3Iu-7","disabled":"SelectSecondary_disabled__1Us8k"};